import React from 'react';
import { useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import { CaffeineContentFields } from 'modules/menu/items/components/ItemDetailsForm/CaffeineContentFields';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { Offer } from '../../../types';
import { FormRowRenderer } from '../FormRowRenderer';
import { StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

const caffeineBaselineTranslationKeys: Record<NonNullable<Offer['caffeine_content']>['units'], string> = {
  mg_per_100_g: 'menu-item.caffeine-baseline-100g',
  mg_per_100_ml: 'menu-item.caffeine-baseline-100ml',
};

export const Caffeine = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();

  const previewComponent = (
    <>
      {offer?.caffeine_content?.value && offer?.caffeine_content?.units
        ? `${offer?.caffeine_content.value}${intl.formatMessage({
            id: 'menu-item.caffeine-baseline-unit',
          })} ${intl.formatMessage({ id: caffeineBaselineTranslationKeys[offer?.caffeine_content.units] })}`
        : '-'}
    </>
  );

  const editComponent = (
    <StyledInputContainer>
      <CaffeineContentFields autoFocus={!values.caffeineContentValue} />
    </StyledInputContainer>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.caffeine' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.caffeineContentValue}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
